import { openDB } from "idb";

export const initDB = async () => {
  const db = await openDB("User", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("users")) {
        db.createObjectStore("users", { keyPath: "id" });
      }
    },
  });
  return db;
};

export const storeUserDetails = async (userData) => {
  const db = await initDB();
  const tx = db.transaction("users", "readwrite");
  const store = tx.objectStore("users");

  const existingData = await store.get(1);
  const addToHomeScreenFlag = existingData?.addToHomeScreenPromptShown || false;

  await store.put({
    id: 1,
    ...existingData,
    ...userData,
    addToHomeScreenPromptShown: addToHomeScreenFlag,
  });

  await tx.done;
};

export const storeAddToHomeScreen = async (userData) => {
  const db = await initDB();
  const tx = db.transaction("users", "readwrite");
  const store = tx.objectStore("users");
  await store.put({ id: 1, ...userData });
  await tx.done;
};

export const getUserDetailsFromDB = async () => {
  try {
    const db = await initDB();
    const transaction = db.transaction("users", "readonly");
    const store = transaction.objectStore("users");
    const user = await store.get(1);
    return user || null;
  } catch (error) {
    console.error("Failed to retrieve token from IndexedDB:", error);
    return null;
  }
};

export const clearUserDetailsFromDB = async () => {
  const db = await initDB();
  const tx = db.transaction("users", "readwrite");
  const store = tx.objectStore("users");

  const existingData = await store.get(1);
  const addToHomeScreenFlag = existingData?.addToHomeScreenPromptShown || false;

  await store.put({ id: 1, addToHomeScreenPromptShown: addToHomeScreenFlag });

  await tx.done;
};

export const getAddToHomeScreenFlag = async () => {
  const user = await getUserDetailsFromDB();
  return user?.addToHomeScreenPromptShown || false;
};

export const setAddToHomeScreenFlag = async (value) => {
  const user = await getUserDetailsFromDB();
  await storeAddToHomeScreen({ ...user, addToHomeScreenPromptShown: value });
};
